import { create_client, delete_client, get_all_clients, update_client } from "../Services/client.service";
import { ClientActionTypes } from "./actionTypes";
import { message } from "antd";
import i18n from "../i18n"; // ton instance i18next

export const sanitizeClientCommercialPayload = (payload = {}, { allowCommercialPlanCode = false } = {}) => {
    const { subscription_plan, commercial_plan_code, ...safePayload } = payload || {};
    if (allowCommercialPlanCode && commercial_plan_code) {
        return { ...safePayload, commercial_plan_code };
    }
    return safePayload;
};

export const fetchAllClients = () => async (dispatch) => {
    dispatch(setClientLoading(true));
    try {
        const res = await get_all_clients();

        if (res.success && res.data) {
            dispatch(setClients(res.data));
        } else {
            dispatch(setClientError(res.error || res.message || i18n.t("clients:messages.loadError")));
        }
    } catch (err) {
        dispatch(setClientError(
            err.response?.data?.error ||
            err.response?.data?.message ||
            err.response?.data?.detail ||
            i18n.t("clients:messages.server")
        ));
    } finally {
        dispatch(setClientLoading(false));
    }
};

const getClientErrorMessage = (err, fallback) =>
    err.response?.data?.error ||
    err.response?.data?.message ||
    err.response?.data?.detail ||
    fallback;

export const createNewClient = (clientData) => async (dispatch) => {
    dispatch(setClientLoading(true));
    try {
        const res = await create_client(
            sanitizeClientCommercialPayload(clientData, { allowCommercialPlanCode: true })
        );

        if (res.success && res.data) {
            dispatch({
                type: ClientActionTypes.ADD_ONE,
                payload: res.data
            });
            message.success(i18n.t("clients:messages.created"));
            return { success: true, data: res.data };
        } else {
            const errorMessage = res.error || res.message || i18n.t("clients:messages.unknown");
            message.error(errorMessage);
            dispatch(setClientError(errorMessage));
            return { success: false, error: errorMessage };
        }
    } catch (err) {
        const errorMessage = getClientErrorMessage(err, i18n.t("clients:messages.server"));
        message.error(errorMessage);
        dispatch(setClientError(errorMessage));
        return { success: false, error: errorMessage };
    } finally {
        dispatch(setClientLoading(false));
    }
};

export const updateExistingClient = (clientId, updateData) => async (dispatch) => {
    dispatch(setClientLoading(true));
    try {
        const result = await update_client(clientId, sanitizeClientCommercialPayload(updateData));

        if (result?.success) {
            dispatch({
                type: ClientActionTypes.UPDATE_ONE,
                payload: result.data
            });
            message.success(i18n.t("clients:messages.updated"));
            return { success: true, data: result.data };
        } else {
            const errorMessage = result?.error || result?.message || i18n.t("clients:messages.unknown");
            message.error(errorMessage);
            dispatch(setClientError(errorMessage));
            return { success: false, error: errorMessage };
        }
    } catch (err) {
        const errorMessage = getClientErrorMessage(err, i18n.t("clients:messages.server"));
        message.error(errorMessage);
        dispatch(setClientError(errorMessage));
        return { success: false, error: errorMessage };
    } finally {
        dispatch(setClientLoading(false));
    }
};

export const deleteClient = (clientId) => async (dispatch) => {
    dispatch(setClientLoading(true));
    try {
        const res = await delete_client(clientId);

        if (res.success) {
            dispatch({
                type: ClientActionTypes.DELETE_ONE,
                payload: clientId
            });
            message.success(i18n.t("clients:messages.deleted"));
            return { success: true };
        } else {
            const errorMessage = res.error || res.message || i18n.t("clients:messages.unknown");
            message.error(errorMessage);
            dispatch(setClientError(errorMessage));
            return { success: false, error: errorMessage };
        }
    } catch (err) {
        const errorMessage = getClientErrorMessage(err, i18n.t("clients:messages.server"));
        message.error(errorMessage);
        dispatch(setClientError(errorMessage));
        return { success: false, error: errorMessage };
    } finally {
        dispatch(setClientLoading(false));
    }
};

// Redux actions
export const setClients = (clients) => ({
    type: ClientActionTypes.SET_DATA,
    payload: clients,
});

export const setClientLoading = (isLoading) => ({
    type: ClientActionTypes.SET_LOADING,
    payload: isLoading,
});

export const setClientError = (errorMessage) => ({
    type: ClientActionTypes.SET_ERROR,
    payload: errorMessage,
});
